export const newsletterForm = {
  confirmation: "Thanks for signing up",
  cta: "Sign up",
  description:
    "Sign up for our newsletter to get helpful tips and more from Conceive experts.",
  heading: "Stay informed with The Egg Drop",
};
